// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import FileAttachmentSinglePanel from '../../../../claim/shared/components/file-attachment-single-panel';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../../claim/shared/components/claim-fields/labeled-date-input';

function handleActualAuditDateChange(date) {

    this.onActualAuditChange(date);

}

function handleAuditResultsChange(event) {

    this.onAuditResultsChange(event.target.value);

}

function handleFileDelete(file) {

    this.onFileDelete(file);

}

function handleFileUploadSuccess(file, dropzone) {

    this.onFileUpload(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

const RecordAuditModalBody = props =>
    <section className='record-audit-modal-body'>
        <div className='row'>
            <LabeledDateInput
                className='actual-audit-date'
                date={props.actualAuditDate}
                isEditable={true}
                isValid={true}
                label='ACTUAL_AUDIT'
                onDateChange={props::handleActualAuditDateChange}
            />
        </div>
        <div className='row'>
            <span className='record-audit-results'>
                <FormattedMessage id='AUDIT_RESULTS'/>
            </span>
            <textarea
                onChange={props::handleAuditResultsChange}
                value={props.auditResults}
            >
            </textarea>
        </div>
        <FileAttachmentSinglePanel
            djsConfig={{maxFiles: 1}}
            file={props.file}
            isRequired={false}
            onFileDelete={props::handleFileDelete}
            onFileUploadSuccess={props::handleFileUploadSuccess}
            serviceConfig={{
                className: 'BUS2222',
                classType: 'BO',
                objectKey: `AUDIT_${props.auditNumber}`
            }}
        />
        <div className='button-group'>
            <button
                onClick={props.onClose}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            <button
                className='primary'
                disabled={!props.auditResults || !props.actualAuditDate}
                onClick={props.onConfirm}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </section>;

RecordAuditModalBody.displayName = 'RecordAuditModalBody';
RecordAuditModalBody.propTypes = {
    actualAuditDate: PropTypes.number,
    auditNumber: PropTypes.string.isRequired,
    auditResults: PropTypes.string.isRequired,
    file: PropTypes.instanceOf(File).isRequired,
    onActualAuditChange: PropTypes.func.isRequired,
    onAuditResultsChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUpload: PropTypes.func.isRequired
};

export default RecordAuditModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-modal/record-audit-modal-body.js